<!--
<app-floating-configurator/>
-->
@if (loginTmpl) {
    <ng-container *ngTemplateOutlet="login"></ng-container>

}
@if (showRecover) {
    <ng-container *ngTemplateOutlet="passRecover"></ng-container>
}

<ng-template #login>
    <div
        class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-screen overflow-hidden">
        <div class="flex flex-col items-center justify-center">

            <div

                style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">

                <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20" style="border-radius: 53px">

                    <div class="text-center mb-8 flex flex-col items-center">
                        <img src="https://mainapi.tiravto.com/Content/Main/logo-b.png" alt="" class="w-40 mb-4">

                        <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-4">Авторизация
                        </div>
                        <span class="text-muted-color font-medium">Заполните данные, чтобы продолжить</span>
                    </div>

                    <div [formGroup]="loginForm" >
                        <label class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">Email или телефон</label>
                        <input pInputText type="text" placeholder="Email address" class="w-full md:w-120 mb-8"
                               formControlName="login" />

                        <label for="password1" class="block text-surface-900 dark:text-surface-0 font-medium text-xl mb-2">Пароль</label>
                        <p-password formControlName="password" placeholder="Password" [toggleMask]="true"
                                     [fluid]="true" [feedback]="false"/>

                        <div class="flex items-center justify-between mt-6 mb-8 gap-8">
                            <div class="flex items-center">
                                <p-checkbox formControlName="rememberMe" binary class="mr-2"/>
                                <label >Запомнить меня</label>
                            </div>
                            <span (click)="showRecovery()" class="font-medium no-underline ml-2 text-right cursor-pointer text-primary">Забыли пароль?</span>
                        </div>
                        <div class="flex flex-col gap-4">
                            <p-button [loading]="loading()" [disabled]="loginForm.invalid" label="Войти" styleClass="w-full" (click)="logging();"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>


<ng-template #passRecover>
    <div
        class="bg-surface-50 dark:bg-surface-950 flex items-center justify-center min-h-screen min-w-screen overflow-hidden">

        <div class="flex flex-col items-center justify-center">
            <div
                style="border-radius: 56px; padding: 0.3rem; background: linear-gradient(180deg, var(--primary-color) 10%, rgba(33, 150, 243, 0) 30%)">
                <div class="w-full bg-surface-0 dark:bg-surface-900 py-20 px-8 sm:px-20" style="border-radius: 53px">
                    <p-icon-field (click)="showRecovery()" class="-ml-10 -mt-10 cursor-pointer">
                        <i class="pi pi-arrow-left" style="font-size: 1.2rem"></i>

                    </p-icon-field>
                    <div class="text-center mb-8 flex flex-col items-center">
                        <img src="https://mainapi.tiravto.com/Content/Main/logo-b.png" alt="" class="w-40 mb-4">

                        <div class="text-surface-900 dark:text-surface-0 text-3xl font-medium mb-4">Восстановление пароля
                        </div>
                        <span class="text-muted-color font-medium">Заполните данные, чтобы продолжить</span>
                    </div>

                    <div class="flex flex-col" [formGroup]="restorePasswordForm">
                        <label for="password1" class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">Логин</label>
                        <input pInputText id="email1" type="text" placeholder="Email или номер телефона " class="w-full md:w-120 mb-8"
                               formControlName="password"/>

                        <div class="mb-7 mx-auto">
                            <re-captcha (resolved)="resolved($event!)" [size]="'normal'" siteKey="{{publicKey}}"
                                        #reCaptcha></re-captcha>
                        </div>
                        <div class="flex flex-col gap-4">
                            <p-button [loading]="loading()"  [disabled]="restorePasswordForm.invalid"  label="Восстановить пароль" styleClass="w-full" (click)="restorePassword()"></p-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</ng-template>

